import { Heading } from "@/components/ui/heading";
import { RegularPageLayout } from "@/components/layout/PageLayouts";
export default function TermsPage() {
	return (
		<RegularPageLayout width="6xl" paddingY="8">
			<section className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
				<Heading>Terms of Use</Heading>
				<div className="mt-6 space-y-4 text-sm leading-7 text-slate-700 sm:text-base">
					<p>By using Text Formatter, you agree to use the service lawfully and responsibly.</p>
					<p>
						You are responsible for the content you submit and for compliance with applicable laws
						and third-party rights.
					</p>
					<p>
						We may update or improve the service over time. Continued use means acceptance of
						updated terms.
					</p>
					<p>
						For commercial API usage, billing and quota limits apply according to your selected plan
						and purchase settings.
					</p>
					<p>
						We reserve the right to suspend or restrict access in cases of abuse, misuse, illegal
						activity, or violations of these terms.
					</p>
				</div>
			</section>
		</RegularPageLayout>
	);
}
